export const transitions = {
  short: '0.15s all ease',
  smooth: '0.6s all cubic-bezier(.28, .28, 0, 1)',
}
